import React from 'react';
import 'bootstrap/dist/js/bootstrap.min';

class MenuLayout extends React.Component {


  static propTypes = {
    activeName : React.PropTypes.string.isRequired,
    onMenuClick : React.PropTypes.func.isRequired,
    activeName2 : React.PropTypes.string.isRequired
  };

  static defaultProps = {
    activeName2 : "111"
  };

  static ACTIVES = {
      "notice":{
          name:"notice",
          contentPage:"noticet.componen"
      },
      "guides":{
          name:"guides",
          contentPage:"guides.html"
      },
      "member":{
          name:"",
          contentPage:""
      },
      "login":{
          name:"",
          contentPage:""
      },
  };

  static ACTIVE_DEFAULT = {
      name:"notice",
      contentPage:"notice.component"
  };


  constructor(props){
    super(props);

  }

  handleMenuClick(activeName, type){
    this.props.onMenuClick(activeName, type || "html");
    // this.props.rootController.handleMenuClick(activeName);
  }

  render () {

    let actives = [];
    actives.push( this.props.activeName == "guides" ? "active" : "" );
    actives.push( this.props.activeName == "member" ? "active" : "");
    actives.push( this.props.activeName == "login" ? "active" : "");
    /*actives.push( this.props.activeName == "wing" ? "active" : "");*/

    return (
        <nav className="navbar navbar-inverse navbar-fixed-top">
          <div className="container-fluid">
            <div className="navbar-header">
              <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
              <a className="navbar-brand bi-coupang" href="/">Home</a>
            </div>
            <div id="navbar" className="navbar-collapse collapse">
              <ul className="nav navbar-nav navbar-right">
                <li className={actives[0]}><a href="/guide" onClick={(e)=>this.handleMenuClick('guides')}>Guides</a></li>
                <li className={actives[1]}><a href="/member">Member</a></li>
              </ul>
            </div>
          </div>
        </nav>
    );
  }
}


export default MenuLayout


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/layout/MenuLayout.jsx